module.exports = __webpack_public_path__ + "static/media/vPay.svg.1594cba0.png";